// NPM Imports
import React from "react";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Internal Imports
import { GlobalUtils } from "../../utils";
import MetamaskLogo from "../../assets/MetaLogo.png";
import { buttonClickEvent } from "../../gtm/gtmutils";
import GTM_EVENTS from "../../gtm/gtmevents";

// Destructuring
const { formatDate } = GlobalUtils;

const EvidenceSummaryPopup = props => (
  <Modal
    open={props.sharingHash && props.showMoreOptions}
    onClose={props.handleClosePopup}
    closeOnOverlayClick
    center
    styles={{
      overlay: {
        background: "rgba(0, 0, 0, 0.60)",
      },
    }}
    classNames={{
      modal: "evidence-summary-wrapper-modal",
      closeButton: "remove-modal-popup-close",
    }}>
    <div>
      <div className="evidence-summary-wrapper">
        <div className="popup-title">Document details</div>
        <hr />
        <div className="document-detail">
          <div className="document-detail-text">
            <div className="doc-detail-title">Document Name</div>
            <div className="doc-detail-subtext">{props.docName}</div>
          </div>
          <div className="shift-right">
            {" "}
            <div className="doc-detail-title shift-right">Document ID</div>
            <div className="doc-detail-subtext">
              {props.isLz
                ? props.docObjectId || props.docObjectIdShared
                : `Doc-${props.docID}`}
            </div>
          </div>
        </div>
        <hr />
        <div>
          <div className="doc-detail-title">Signers</div>
          <ul className="evidence-signer-list-wrapper">
            {Object.values(props.signatories)
              .filter(
                (v, i, a) =>
                  a.findIndex(t => t.signer_email === v.signer_email) === i,
              )
              .map(item => (
                <li>
                  <div
                    className="send-list-item"
                    data-test="cta-clone-document-button">
                    <div className="btn-send-icon">
                      <img
                        src={item.image_url}
                        alt="user-img"
                        className="evidence-summary-user-ico"
                      />
                    </div>
                    <div>
                      <div className="btn-send-heading">
                        {" "}
                        {item.first_name} {item.last_name}
                      </div>
                      <div className="btn-send-desc">{item.signer_email}</div>
                    </div>

                    <div className="shift-right">
                      {item.is_declined && (
                        <div className="btn-send-desc declined">DECLINED</div>
                      )}
                      {!item.is_declined &&
                        item.signed_ip !== "" &&
                        item.sign_type !== "META" && (
                          <div className="btn-send-desc">
                            IP:{item.signed_ip}
                          </div>
                        )}
                      {!item.is_declined && item.sign_type === "META" && (
                        <div
                          className="btn-send-desc"
                          style={{
                            display: "flex",
                            backgroundColor: "#dcdcdc",
                            borderRadius: "8px",
                          }}>
                          <img
                            src={MetamaskLogo}
                            alt="MetamaskLogo"
                            width="20"
                          />
                          <span>{item.meta_address}</span>
                        </div>
                      )}
                      {item.signed_at && (
                        <div className="btn-send-desc">
                          {formatDate(item.signed_at, "lll")}
                        </div>
                      )}
                    </div>
                  </div>
                </li>
              ))}
          </ul>
        </div>
        <hr />
        <div className="evidence-summary">
          <div className="doc-detail-title">
            <FontAwesomeIcon
              icon={["far", "clipboard-list-check"]}
              className="recipientesignheaderbuttons-icon"
            />{" "}
            Evidence Summary Certificate
          </div>
          {props.docStage === "COMPLETED" ? (
            <div className="document-detail doc-detail-subtext underlined">
              <div className="document-detail-text">
                <span
                  className="hand-cursor"
                  role="button"
                  data-test="evidence-summary-button"
                  tabIndex="0"
                  onClick={() =>
                    props.docStage === "COMPLETED"
                      ? props.downloadEvidenceSummary()
                      : {}
                  }
                  onKeyPress={() => {}}>
                  {props.docName} - Evidence Summary.pdf
                </span>
              </div>
              <div
                className="shift-right hand-cursor"
                role="button"
                data-test="evidence-summary-button"
                tabIndex="0"
                onClick={() =>
                  props.docStage === "COMPLETED"
                    ? props.downloadEvidenceSummary()
                    : {}
                }
                onKeyPress={() => {}}>
                <FontAwesomeIcon
                  icon={["far", "download"]}
                  className="recipientesignheaderbuttons-icon"
                />
              </div>
            </div>
          ) : (
            <div className="doc-detail-subtext">
              <em>Generated after the document is signed</em>
            </div>
          )}
        </div>
        <div
          className="hand-cursor"
          role="button"
          tabIndex={0}
          onClick={() => {
            buttonClickEvent(
              GTM_EVENTS.SIGNINGCEREMONY_DOCDETAILSPOPUP_TNC_LINK_CLICK,
            );
            window.open(
              "https://docs.esign.legalzoom.com/electronic-record-and-signature-disclosure-and-agreement.pdf",
              "_blank",
            );
          }}
          onKeyDown={() => {}}>
          <div className="doc-detail-title">
            {" "}
            <FontAwesomeIcon
              icon={["far", "file-contract"]}
              className="recipientesignheaderbuttons-icon"
            />{" "}
            Terms and Conditions
          </div>
          <div className="doc-detail-subtext underlined">
            LegalZoom Electronic Record and Signature Disclosure and
            Agreement.pdf
            {/* {`${
              props.isLz ? "LegalZoom" : "Revv"
            } Electronic Record and Signature Disclosure and
            Agreement.pdf`} */}
          </div>
        </div>
      </div>
    </div>
  </Modal>
);

export default EvidenceSummaryPopup;
